import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { Button, Stack } from "@mui/material";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { LoadState } from "../../../../redux/common";
import { findHomeworkCheckRequest, homeworkCheckChange, HomeworkCheckChangeRequest, selectHomeworkCheckChange } from "../../../../redux/homework/homeworkCheckChangeSlice";
import { HomeworkCheckInfo, HomeworkDone } from "../../../../redux/homework/homeworkCheckSlice";
import { HomeworkInfo } from "../../../../redux/homework/homeworkSlice";

interface ContentProps {
    homework: HomeworkInfo;
    studentId: string;
    check?: HomeworkCheckInfo;
}

const HomeworkReviewCheckCell = (props: ContentProps) => {
    const { studentId } = props;
    const homeworkChanges = useAppSelector(selectHomeworkCheckChange);
    const dispatch = useAppDispatch();

    const [requestData, setRequestData] = useState({
        schoolId: props.homework.schoolId,
        classroomId: props.homework.classroomId,
        homeworkId: props.homework.id,
        studentId: studentId,
        done: props.check?.done || HomeworkDone.No
    } as HomeworkCheckChangeRequest);

    const request = findHomeworkCheckRequest(homeworkChanges.requests, requestData);
    const state = request?.state.state || LoadState.NotStarted;

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <Button 
                color={state == LoadState.Loading ? undefined : "success"}
                onClick={() => {
                    const data = { ...requestData, done: HomeworkDone.Yes };
                    dispatch( homeworkCheckChange(data) );
                }}
                variant={ props.check?.done == HomeworkDone.Yes ? "contained" : "outlined" }
                disabled={state == LoadState.Loading}>
                <DoneIcon />
            </Button>
            <Button 
                color={state == LoadState.Loading ? undefined : "error"}
                onClick={() => {
                    const data = { ...requestData, done: HomeworkDone.No };
                    dispatch( homeworkCheckChange(data) );
                }}
                variant={ props.check?.done == HomeworkDone.No ? "contained" : "outlined" }
                disabled={state == LoadState.Loading}>
                <CloseIcon />
            </Button>
        </Stack>
    );
};

export default HomeworkReviewCheckCell;
